import { ErrorLike } from '@apollo/client';
import { usePrevious } from 'common-react/utils/hooks/usePrevious';
import { useEffect } from 'react';

export const useQueryErrorAlert = (
  error: ErrorLike | undefined,
  setErrorAlert: () => void,
) => {
  const prevError = usePrevious(error);

  useEffect(() => {
    if (error) {
      if (prevError && error) {
        setErrorAlert();
      }
    }
  }, [error, prevError]);
};
